// extracted by mini-css-extract-plugin
export var body = "_og-8";
export var button = "_og-0";
export var closeButton = "_og-5";
export var content = "_og-3";
export var empty = "_og-f";
export var grid = "_og-c";
export var header = "_og-4";
export var icon = "_og-1";
export var option = "_og-d";
export var optionSelected = "_og-e";
export var overlay = "_og-2";
export var searchIcon = "_og-a";
export var searchInput = "_og-b";
export var searchWrapper = "_og-9";
export var title = "_og-6";
export var visuallyHidden = "_og-7";